import React, { useEffect, useState } from "react";
import TransparentButton from "../../biblio/Buttons/TransparentButton";
import NavigationMenu from "../../biblio/Tabs/NavigationMenu";
import { Divider } from "antd";
import whiteLogo from "../../assets/logo/white-nav-logo.svg";
import logo from "../../assets/logo/MainLogo1.svg";
import BurgerMenu from "./BurgerMenu";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../apis/store";
import { getBeneficiaryDetails } from "../../apis/actions/recipient.actions";
import ProfileIcons from "../../biblio/ProfileIcons/ProfileIcons";
import { getSponsorDetails } from "../../apis/actions/sponsor.actions";
import CardPalm from "../../components/card-palm/CardPalm";
import { isRoleEndower, isRoleSponsor } from "../profile/sponsor/orphans/utils";
import { getParticipantDetails } from "../../apis/actions/participants.actions";

interface NavbarProps extends React.HTMLAttributes<HTMLDivElement> {
  id?: string;
  variant: "projectDetails" | "homePage";
}
const NavBar = ({ variant, ...props }: NavbarProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState<boolean>(false);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const OtpId = useSelector((state: RootState) => state?.recipient?.OtpId);
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  const [, setIsSmallScreen] = useState(false);

  const [cookies] = useCookies(["apiKey", "role"]);
  const isConnected = cookies?.apiKey ?? false;
  const role = cookies?.role;
  const dispatch = useDispatch<AppDispatch>();
  const location = useLocation();
  useEffect(() => {
    if (cookies.apiKey)
      role === "beneficiary"
        ? dispatch(getBeneficiaryDetails())
        : isRoleEndower(role)
        ? dispatch(getParticipantDetails())
        : dispatch(getSponsorDetails({ sponsor_id: OtpId }));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);
  const beneficiary = useSelector(
    (state: RootState) => state?.recipient?.beneficiaryDetails
  );
  const sponsor = useSelector(
    (state: RootState) => state?.sponsor?.sponsorDetails
  );
  const participantDetails = useSelector(
    (state: RootState) => state?.participants?.participantDetails
  );
  const { palms } = useSelector((state: RootState) => state.palm);
  /*
  useEffect(() => {
    dispatch(getPalms());
  }, [dispatch]);
*/
  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 1598);
    };

    handleResize(); // check on mount
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <nav
      {...props}
      className={`takaful--navigation-bar ${
        scrolled && variant === "homePage"
          ? "scrolled-navbar-bg-white"
          : scrolled && variant === "projectDetails"
          ? "scrolled-navbar-bg-blue"
          : !scrolled && variant === "homePage"
          ? "scrolled-navbar-bg-white takaful--fixed-image"
          : ""
      } ${props.className ?? ""}`}
    >
      <div className="takaful--navbar-content">
        <div
          className={`takaful--navbar-list ${
            variant === "homePage" ? "" : "text-color"
          }`}
        >
          {location.pathname === "/profile" ? (
            <ProfileIcons />
          ) : (
            <div className="takaful--navbar-profile-btn">
              
              <TransparentButton
                title={
                  isConnected ? (
                    <span className="takaful--title">
                      {isRoleSponsor(role)
                        ? sponsor?.name
                        : isRoleEndower(role)
                        ? participantDetails?.name
                        : beneficiary?.name}
                    </span>
                  ) : (
                    t("text-btn")
                  )
                }
                onClick={() => {
                  isConnected ? navigate("/profile") : navigate("/login");
                }}
              />{/*
              {isSmallScreen ? (
                <Tooltip
                  overlayClassName="takaful--share-tooltip"
                  placement="right"
                  title="الإنتقال إلى النسخة القديمة"
                >
                  <TransparentButton
                    title={<RollbackOutlined  style={{ fontSize: 18 }} />} // only icon
                    onClick={() => {
                      window.location.href =
                        "https://takaful.soogp1.com/index.php?p=111";
                    }}
                    className="takaful--return-button"
                  />
                </Tooltip>
              ) : (
                <TransparentButton
                  title={"الإنتقال إلى النسخة القديمة"}
                  onClick={() => {
                    window.location.href =
                      "https://takaful.soogp1.com/index.php?p=111";
                  }}
                  className="takaful--return-button"
                />
              )}
              
              <PrimaryButton
                className="takaful--tansparent-button takaful--palm-button"
                title="وقف النخيل"
                direction="rtl"
                icon={
                  <img
                    src={palm}
                    alt="folder"
                    width={28}
                    className="takaful--palm-icon"
                  />
                }
                onClick={() => setIsModalOpen(true)}
              />
              */}
            </div>
          )}

          <NavigationMenu variant={variant} />
          <figure className="takaful--navbar-logo">
            <img
              onClick={() => navigate("/")}
              src={variant === "homePage" ? logo : whiteLogo}
              alt="logo"
            />
          </figure>
        </div>
        {variant === "homePage" && (
          <Divider className="takaful--navbar-divider" />
        )}
      </div>
      <figure className="takaful--navbar-logo mobile--logo">
        <img
          onClick={() => navigate("/")}
          src={variant === "homePage" ? logo : whiteLogo}
          alt="logo"
        />
      </figure>

      <BurgerMenu variant={variant} palms={palms} />
      <CardPalm
        palms={palms}
        isPalmModalOpen={isModalOpen}
        setIsPalmModalOpen={(open: any) => setIsModalOpen(open)}
      />
    </nav>
  );
};

export default NavBar;
